<template>
<el-drawer title="校区变更" :visible.sync="show" :before-close="close" :close-on-press-escape="false" :destroy-on-close="true" :wrapperClosable="false" :size="400">
	<p style="font-size: 20px;font-weight: 700;padding-left: 10px;margin-bottom: 20px;">将<span style="color: #f00;">{{name}}</span>的校区变更为：</p>
	<el-form :model="form" :rules="rules" ref="form" label-width="100px">
		<el-form-item class="item" label="主要校区" prop="firstsch">
			<el-select v-model="form.firstsch" placeholder="主要校区" @change="firstschchange"><el-option v-for="onesch in sch" :key="'firstsch'+onesch.id" :label="onesch.name" :value="onesch.id"></el-option></el-select>
		</el-form-item>
		
		<el-form-item class="item" label="次要校区" prop="sch">
			<el-select multiple v-model="form.sch" placeholder="次要校区"><el-option v-for="onesch in sch" :key="'sch'+onesch.id" :label="onesch.name" :value="onesch.id" :disabled="form.firstsch===onesch.id ? true : false"></el-option></el-select>
		</el-form-item>
		
		<el-form-item class="item" label="起始日期" prop="startTimeS">
			<el-date-picker style="width: 200px;" v-model="form.startTimeS" type="date" placeholder="选择日期"></el-date-picker>
		</el-form-item>
		
		<div class="m15" style="text-align: right;">
			<el-button @click="reset">重置</el-button>
			<el-button type="primary" @click="submit">提交</el-button>
		</div>
	</el-form>
</el-drawer>
</template>

<script>
export default{
	name:'repsch',
	data() {
		return {
			name:"",
			firstsch:"",
			othersch:[],
			startTimeS:"",
			form:{
				firstsch:"",
				sch:[],
				startTimeS:""
			},
			rules:{
				firstsch:[{validator:(rule,value,callback)=>{
					if(this.form.firstsch===""){
						callback("请选择主要校区")
						return
					}
					if(this.form.firstsch===this.firstsch&&this.myfun.objIsSame(this.form.sch,this.othersch)&&this.startTimeS===this.myfun.date2str(this.form.startTimeS)){
						callback("校区未更改")
						return
					}
					callback()
				},trigger:'blur'}],
				sch:[{validator:(rule,value,callback)=>{
					if(this.form.firstsch===this.firstsch&&this.myfun.objIsSame(this.form.sch,this.othersch)&&this.startTimeS===this.myfun.date2str(this.form.startTimeS)){
						callback("校区未更改")
						return
					}
					callback()
				},trigger:'blur'}],
				startTimeS:[{validator:(rule,value,callback)=>{
					if(this.form.startTimeS===""){
						callback("请选择起始日期")
					}
					callback()
				},trigger:'blur'}]
			}
		}
	},
	props:{
		user:{
			type:Object
		},
		show:{
			type:Boolean
		},
		sch:{
			type:Array
		}
	},
	watch:{
		show(n){
			if(!n){
				return
			}
			this.name=this.user.name
			this.firstsch=this.user.sch[0].id,
			this.form.firstsch=this.user.sch[0].id,
			this.othersch=[]
			this.form.sch=[]
			for(let i=1;i<this.user.sch.length;i++){
				this.othersch.push(this.user.sch[i].id)
				this.form.sch.push(this.user.sch[i].id)
			}
			this.startTimeS=this.user.sch[0].stime
			this.form.startTimeS=this.user.sch[0].stime
		}
	},
	methods:{
		close(){
			this.$emit("close",{isrep:false})
		},
		firstschchange(){
			this.form.sch=[]
		},
		reset(){
			this.$refs.form.resetFields()
		},
		submit(){
			this.$refs.form.validate((e)=>{
				console.log(this.form)
				if(!e){
					return
				}
				//整理数据，提交服务器
				let user={
					id:this.user.id,
					sch:[],
				}
				let stime=this.myfun.date2str(this.form.startTimeS)
				user.sch.push({id:this.form.firstsch,isfirst:true,stime})
				this.form.sch.forEach(e=>{
					user.sch.push({id:e,isfirst:false,stime})
				})
				this.myfun.Loading()
				const formdata = new FormData()
				formdata.append("user",JSON.stringify(user))
				this.axios.post("data:repsch",formdata).then(e=>{
					this.myfun.Loadingclose()
					if(!e)return
					this.myfun.messageSuc("修改成功")
					this.$emit("close",{isrep:true,data:e})
				})
			})
		}
	}
}
</script>

<style>
</style>
